/**
 * @ngdoc service
 * @name user
 *
 * @description User api service.
 */
module.factory('user', ['$q', '$timeout', function($q, $timeout) {
    'use strict';
    return {
        getUser: function(memberNumber) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve({
                    user: {
                        "id": 4,
                        "field_email": "liam.wilde@mail.com",
                        "field_member_id": 8644685,
                        "field_civility": "M",
                        "field_lastname": "Wilde",
                        "field_firstname": "Liam",
                        "field_birth_date": "2017-05-21",
                        "field_mobile": "0612345678",
                        "field_legal_guardian": {
                            "id": 3,
                            "field_email": "frank.wilde@mail.com",
                            "field_member_id": 8644699,
                            "field_civility": "M",
                            "field_lastname": "Wilde",
                            "field_firstname": "Frank",
                            "field_birth_date": "1987-03-03",
                            "field_mobile": "0612345678",
                            "field_legal_guardian": {}
                        }
                    }
                });
            }, 1000);
            return deferred.promise;
        }
    };
}]);
